// @flow

import React, { PureComponent, Fragment } from "react";
import { orderBy } from "lodash";
import type { SurfaceChanges as SurfChanges } from "@tvg/types/Race";
import { formatPostTime, formatPeriod } from "@tvg/formatter/dates";

import { arrowForward } from "../../_static/Icons/icons";

import buildColor from "../../_static/ColorPalette";
import {
  Title,
  EmptyStateLabel,
  List,
  Time,
  Dt,
  Dl,
  ArrowIcon,
  ChangeLblContainer,
  KeywordLbl
} from "./styled-components";

type Props = {
  changes: SurfChanges,
  raceNumber: number
};

type Change = {
  keyword: string,
  oldValue: string,
  newValue: string,
  date: string
};

type Changes = Array<Change>;

const getDistanceArray = (changesArray): Changes =>
  changesArray && changesArray.length
    ? changesArray.map((change) => ({
        keyword: "Distance",
        oldValue: `${
          change.oldValue.value
        }${change.oldValue.code.toLowerCase()}`,
        newValue: `${
          change.newValue.value
        }${change.newValue.code.toLowerCase()}`,
        date: change.date
      }))
    : [];

const getArray = (changesArray, keyword: string): Changes =>
  changesArray && changesArray.length
    ? changesArray.map((change) => ({
        keyword,
        oldValue: change.oldValue,
        newValue: change.newValue,
        date: change.date
      }))
    : [];

export default class SurfaceChanges extends PureComponent<Props> {
  static defaultProps = {
    changes: [],
    raceNumber: 0
  };

  renderChanges() {
    const changes: Changes = [
      ...getArray(this.props.changes.course, "Course"),
      ...getArray(this.props.changes.tempRailDistance, "Temp Rail Distance"),
      ...getArray(this.props.changes.condition, "Track Condition"),
      ...getDistanceArray(this.props.changes.distance)
    ];

    return changes.length ? (
      <List>
        {orderBy(changes, ["date"], ["desc"]).map((change: Change) => (
          <li key={`surface-change-${change.date}-${change.keyword}`}>
            <Time>
              {formatPostTime(change.date)} {formatPeriod(change.date)}
            </Time>
            <Dl>
              <Dt>
                <KeywordLbl>{change.keyword}</KeywordLbl>
                <ChangeLblContainer>
                  <span>{change.oldValue || "Set to\u00A0"}</span>
                  {change.newValue && change.oldValue && (
                    <ArrowIcon
                      icon={arrowForward}
                      size={12}
                      color={buildColor("grey", "900")}
                    />
                  )}
                  {change.newValue && <strong>{change.newValue}</strong>}
                </ChangeLblContainer>
              </Dt>
            </Dl>
          </li>
        ))}
      </List>
    ) : (
      <EmptyStateLabel> There are no surface types changes</EmptyStateLabel>
    );
  }

  render() {
    return (
      <Fragment>
        <Title>
          Surface{!!this.props.raceNumber && ` - R${this.props.raceNumber}`}
        </Title>
        {this.renderChanges()}
      </Fragment>
    );
  }
}
